import { useEffect, useState } from "react";
import { offerApi } from "../../../services/offerApi";

// Les images d'offre sont servies par l'API authentifiée : chaque « asset:ID » est lu
// une fois en blob puis partagé par toutes les slides. Contenu immuable : le cache
// vit aussi longtemps que la page.
const cache = new Map();

const idOf = (ref) => (typeof ref === "string" && ref.startsWith("asset:") ? ref.slice(6) : null);

// La page de rendu (sans session) lit les images avec son jeton plutôt qu'avec l'API authentifiée.
let fetchBlob = (assetId) => offerApi.assetBlob(assetId);
export const setAssetFetcher = (fetcher) => {
  const previous = fetchBlob;
  fetchBlob = fetcher;
  return previous;
};

const load = (ref) => {
  const assetId = idOf(ref);
  if (!assetId) return Promise.resolve(null);
  if (!cache.has(assetId)) {
    cache.set(assetId, fetchBlob(assetId).then((blob) => URL.createObjectURL(blob)).catch(() => null));
  }
  return cache.get(assetId);
};

export const useAssetUrl = (ref) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let active = true;
    setUrl(null);
    load(ref).then((value) => { if (active) setUrl(value); });
    return () => { active = false; };
  }, [ref]);
  return url;
};

// Pour l'impression : attendre que toutes les images demandées soient chargées.
export const waitForAssets = () => Promise.all([...cache.values()]);

const readBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(String(reader.result).split(",")[1] || "");
  reader.onerror = () => reject(new Error("Lecture de l'image impossible."));
  reader.readAsDataURL(file);
});

export const ACCEPTED_IMAGES = ["image/png", "image/jpeg", "image/webp", "image/gif"];

export const uploadImage = async (file) => {
  if (!ACCEPTED_IMAGES.includes(file.type)) throw new Error("Formats acceptés : PNG, JPEG, WebP, GIF.");
  if (file.size > 5 * 1024 * 1024) throw new Error("Image trop lourde (5 Mo au plus).");
  const result = await offerApi.uploadAsset({ filename: file.name, content_type: file.type, data: await readBase64(file) });
  return result.ref;
};
